import './PhilAlert.css';

import classNames from 'classnames';
import React from 'react';

import { PhilAlertViewModel } from './PhilAlertViewModel.csharp';

export const PhilAlert = (props: PhilAlertViewModel) => {
    if (!props.heading && !props.description) {
        return null;
    }

    return (
        <section className="PhilAlert">
            <div className={classNames('PhilAlert__Inner', (!props.heading || !props.description) && 'PhilAlert__Inner--OneText')}>
                <span className="PhilAlert__Icon" />
                <div className="PhilAlert__TextWrapper">
                    {props.heading && <h2 className="PhilAlert__Heading">{props.heading}</h2>}
                    {props.heading && props.description && <p className="PhilAlert__Description">{props.description}</p>}
                    {!props.heading && props.description && <h2 className="PhilAlert__Description">{props.description}</h2>}
                </div>
            </div>
        </section>
    );
};
